
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.643 37.642c-2.3-2.3-4.7-6.3-8.1-4-.8.5-1.6 2.3-2.5 2.5-.9.2-3.5-1.8-4.4-2.4-3.4-2.4-5.8-5.3-7.6-8.8 1.8-1.8 3.7-3.8 2.8-6.7-1-2.9-4.8-5.3-6.9-7.4 0-.1-.1-.1-.2-.2-5.3-3.3-9.2 7-8.7 11 .9 7.7 6.9 14.6 12.3 19.7 4.5 4.2 12.8 11.2 19.7 8.9 2.2-.8 5.1-3.4 6.1-5.5 1.4-3-.5-5.1-2.5-7.1zm-.5 7c-4.5 4.5-9.9 2.5-14.9-.5-6.2-3.8-11.7-9.2-15.6-15.4-1.5-2.5-3.7-6.1-3.4-9.2.3-2.4 4.3-7.5 7.1-5.8 1.6 1.5 3.8 3.1 5 4.9 1.3 2-.4 2.8-2 4.5-.5.5-.4 1.9-.1 2.5 3 6.4 7.2 10.4 13.5 13.7.2.1.4 0 .5-.2.8-.8 1.7-2.2 2.7-2.7 2.4-1.3 3.5.4 5 1.8.9.9 2.9 2.2 3.4 3.4.6 1.6.1 1.7-1.2 3z"}})])
          )
        }
      }
    